import { useEffect, useRef } from "react"

import Style from "./style"

import usePostUtilSms from "entity/util/usePostUtilSms"
import usePostUtilSmsConfirm from "entity/util/usePostUtilSmsConfirm"
import useGetManagerId from "entity/auth/useGetManagerId"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"
import useConfrimCookie from "shared/model/useConfrimCookie"

const FindManagerId = () => {

    const contactRef = useRef()
    const confirmRef = useRef()

    const [sendState, sendEvent] = usePostUtilSms(contactRef)
    const [confirmEvent] = usePostUtilSmsConfirm(contactRef, confirmRef)
    const [findId, setFindId] = useGetManagerId()

    const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()

    useEffect(() => {
        return () => {
            deleteConfirmCookie()
        }
    }, [])

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <h2>매니저 아이디 찾기</h2>

                <Style.FormDiv>
                    <DefaultInput label="연락처" inputRef={contactRef} placeholder="'-' 없이 숫자만 입력">
                        <DefaultButton small fitWidth clickEvent={sendEvent} deactive={confirmCookie}>인증번호 받기</DefaultButton>
                    </DefaultInput>
                    {sendState &&
                        <div>
                            <DefaultInput label="인증번호" inputRef={confirmRef} placeholder="6글자의 숫자만 입력">
                                <DefaultButton small fitWidth clickEvent={confirmEvent} deactive={confirmCookie}>인증하기</DefaultButton>
                            </DefaultInput>
                            {confirmCookie && <Style.Guide>인증되었습니다.</Style.Guide>}
                        </div>
                    }
                </Style.FormDiv>

                {findId && <Style.IdResult>매니저님의 아이디는 "<span>{findId?.data?.id}</span>" 입니다.</Style.IdResult>}

                <Style.BtnDiv>
                    <DefaultButton clickEvent={setFindId}>아이디 찾기</DefaultButton>
                </Style.BtnDiv>

            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default FindManagerId